import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
	deleteReturn
} from '../../../../redux/actions';

class DeleteReturns extends Component {

	constructor(props) {
        super(props);
        this.state = {
			deleteReturnsForm: {
				params: {
					referenceNumber: '',
				},
				errors: {
					referenceNumberError: '',
				}
			},
			serviceCallCompleted: false,
			errorMessage: '',
			confirmationMessage: '',
        }
    }

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		const name = event.target.name;
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: event.target.value
				}
			}
		}, () => {
			if(self.state[formName].errors[name + 'Error']) {
				self.setState({
					[formName]: {
						...self.state[formName],
						errors: {
							...self.state[formName].errors,
							[name+'Error']: ''
						},
					},
				});
			}
		});
	}

	componentWillMount() {
		const self = this;
		const { userDetails } = self.props.state.user;
		// redirect user to home page if he has not access to this page
		if(userDetails && !userDetails.isSiteManagementAccess) {
			browserHistory.push('/home');
		}
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.deleteReturnsForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }

		self.setState({
			params,
			errors,
			serviceCallCompleted: false,
			errorMessage: '',
			confirmationMessage: '',
		}, () => {
			if(!formError) {
				self.props.deleteReturn(`requestType=deleteReturn&referenceNumber=${self.state.deleteReturnsForm.params.referenceNumber.toUpperCase()}`, response => {
					if(response.status && response.responseObject) {
						self.setState({
							serviceCallCompleted: true,
							confirmationMessage: response.responseMessage
						});
					} else {
						self.setState({
							errorMessage: response.responseMessage
						});
					}
				});
			}
		});
	}

	returnToPreviousScreen(e) {
		e.preventDefault();
		// reset state so user can enter data again.
		this.setState({
			deleteReturnsForm: {
				params: {
					referenceNumber: '',
				},
				errors: {
					referenceNumberError: '',
				}
			},
			serviceCallCompleted: false,
			errorMessage: '',
			confirmationMessage: '',
		});
	}

    render() {
		const self = this;
		const { deleteReturnsForm: { params, errors } } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Delete Returns</h1>
				</div>
				{this.state.errorMessage?<p className="red bold">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold">{this.state.confirmationMessage}</p>:null}
				<div className="largePush">
					<table style={{width: '53%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td className="first-column">Return/Credit Reference#</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} value={params.referenceNumber} className={errors.referenceNumberError} type="text" name="referenceNumber" onChange={this.updateParams.bind(this, 'deleteReturnsForm')} onKeyPress={this.props.acceptAlphaNumericOnly} />
								</td>
							</tr>
							{!this.state.serviceCallCompleted && <tr>
								<td className="first-column" />
								<td className="middle-column">
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Delete" />
								</td>
							</tr>}
						</tbody>
					</table>
					{this.state.serviceCallCompleted && <div>
						<p><a href="" onClick={this.returnToPreviousScreen.bind(this)}>Return to Previous Screen</a></p>
						<div className="clear" />
					</div>}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	deleteReturn: (payload, callback) => dispatch(deleteReturn(payload, callback)),
});

DeleteReturns = connect(mapStateToProps, mapDispatchToProps)(DeleteReturns);
export default DeleteReturns;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/DeleteReturns/index.js